import CodeMirror from 'codemirror';
import { IModelField } from '../../index.d';
import { matchFqnPath } from '../../../utils/fqn';
import { hasTokenIncludes } from '../../utils/codemirror';


export function matchFqnPathHint({ editor, position, fqn }: {
    editor: CodeMirror.Editor,
    position: CodeMirror.Position,
    fqn: IModelField
}) {
    try {
        const currentToken = editor.getTokenAt(position);

        const path = getPreviousFqnPath(editor, currentToken);
        if (path) {
            const { fields } = (matchFqnPath(fqn, path) as IModelField) || { fields: undefined };
            const isCurrentDot = hasTokenIncludes(currentToken, ['dot']);

            const beingReplaced = isCurrentDot ? 0 : 1;
            const hintStrings = (isCurrentDot ? Object.keys(fields) :
                Object.keys(fields).filter(field => {
                    return field.includes(currentToken.string);
                })).reduce((result, key) => {
                    const field = fields[key];
                    result.push((field.isArray) ? key + '[]' : key);
                    return result;
                }, [] as string[]);

            // 如果匹配的字符串是完整的路径，且只匹配到一个，则不需要智能提示
            // 如：this.order.status 当输入的路径是完整的正确路径，且只匹配到一个结果
            if (!isCurrentDot && hintStrings.length === 1 && hintStrings[0] === currentToken.string) {
                return;
            }

            if (fields) {
                return {
                    beingReplaced,
                    hints: hintStrings.map(field => {
                        return { text: field, displayText: field };
                    })
                };
            }
        }

    } catch (err) {
        // console.error(err);
    }
}


function getPreviousFqnPath(editor: CodeMirror.Editor, token: CodeMirror.Token) {
    const paths: string[] = [];
    let previousToken = token;
    while (previousToken = editor.getTokenAt({ line: previousToken.state.line, ch: previousToken.start })) {
        if (hasTokenIncludes(previousToken, ['dot'])) {
            if (paths[paths.length - 1] === '.') {
                return undefined;
            }
            paths.push(previousToken.string);
            continue;
        }

        if (hasTokenIncludes(previousToken, ['property', 'fqn'])) {
            paths.push(previousToken.string);
            if (hasTokenIncludes(previousToken, ['root'])) {
                break;
            } else {
                continue;
            }
        }

        break;
    }
    return paths.filter(item => item !== '.').reverse().join('.');
}
